import { useForm } from "react-hook-form";

import { GenericLandingCard, LoginForm } from "components";
import { GoToRegisterBtn, LoginBtn } from "components/buttons";

export const LoginPage = () => {
  const { control, handleSubmit } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
      password: "",
      rememberMe: false,
    },
    shouldFocusError: false,
  });
  return (
    <GenericLandingCard
      rightColumn={<LoginForm control={control} handleSubmit={handleSubmit} />}
      leftInteraction={<GoToRegisterBtn />}
      rightInteraction={<LoginBtn />}
    />
  );
};
